import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import { TickerPlayer, MediaPlayer } from 'signoxe/components';
import { getTickerSeries } from 'signoxe/selectors';
import RGL from 'react-grid-layout';
import './styles.scss';
import { APP_ROOT } from "signoxe/constants/config";

const ReactGridLayout = RGL.WidthProvider(RGL);


class RegionMediaPlayer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mediaIndex: 0,
    };
  }

  static propTypes = {
    playlist: PropTypes.object,
    match: PropTypes.object,
  };

  nextMedia = () =>
    this.setState({
      mediaIndex: (this.state.mediaIndex + 1) % this.props.playlist.items.length,
    })

  getMedia() {
    if (this.props.playlist && this.props.playlist.items && this.props.playlist.items.length > 0) {
      const item = this.props.playlist.items[this.state.mediaIndex].item;
      return {
        ...item,
        asset_url: (item.asset_url && item.asset_url[0] === '/') ? (APP_ROOT + item.asset_url) : item.asset_url
      };
    }
  }

  render() {
    const media = this.getMedia();
    if (!this.props.playlist || !media) return null;

    const {type, duration, asset_url} = media;
    console.log("🚀 ~ file: index.js ~ line 49 ~ RegionMediaPlayer ~ render ~ duration", duration)

    return (
        <div className="media-container">
          <MediaPlayer type={type}
                       duration={duration}
                       url={asset_url}
                       index={this.state.mediaIndex}
                       onPlaybackDone={this.nextMedia}/>
        </div>
    );
  }

}

class ChannelLayoutPreview extends React.Component {
  static propTypes = {
    regions: PropTypes.array.isRequired,
    playlists: PropTypes.array,
    tickerSeries: PropTypes.object,
    layoutWidth: PropTypes.number.isRequired,
    layoutHeight: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tickerIndex: 0,
    };
    this.nextTicker = this.nextTicker.bind(this);
  }

  nextTicker(currentIndex, allowNextTicker) {
    return () => {
      if (!allowNextTicker) {
        return;
      }
      const nextIndex = currentIndex + 1;
      this.setState({
        tickerIndex: nextIndex % this.props.tickerSeries.tickers.length,
      })
    }
  }

  getTicker() {
    if (this.props.tickerSeries &&
      this.props.tickerSeries.tickers && this.props.tickerSeries.tickers.length > 0) {
      return this.props.tickerSeries.tickers[this.state.tickerIndex];
    }
    else return null;
  }

  render() {
    const {layoutWidth, layoutHeight, playlists, regions} = this.props;
    const ticker = this.getTicker();

    return (
            <div className={classNames('layout-editor flex-container flex-direction-column')}>
              <ReactGridLayout className="layout flex-container flex-direction-row"
                cols={12}
                maxRows={12}
                preventCollision
                margin={[0, 0]}
                compactType={null}
                rowHeight={layoutHeight/12}
                style={{height: layoutHeight, width: layoutWidth}}
                isDraggable={false}
                isResizable={false}
                width={layoutWidth}
                >
                {regions.map((region, index) => {
                  const playlistData = _.findLast(playlists,
                    playlist => parseInt(playlist.id) == parseInt(region.playlist)
                  );
                  return (<div key={region.id} data-grid={region.data_grid}>
                    <RegionMediaPlayer playlist={playlistData} parentHeight/>
                  </div>);
                }
              )}
              </ReactGridLayout>
              {ticker && <TickerPlayer
                  className="flex-container flex-direction-row"
                  disableOverlay
                  width={layoutWidth}
                  background={ticker.background}
                  colour={ticker.colour}
                  outline={ticker.outline}
                  fontFamily={ticker.font_family}
                  fontSize={ticker.font_size}
                  speed={ticker.speed}
                  text={ticker.text}
                  isURL={ticker.is_url}
                  index={this.state.tickerIndex}
                  onTickerEnd={this.nextTicker}/>
              }
              {/* </div> */}
          </div>
    );
  }
}

export default connect((state, props) => ({
  tickerSeries: getTickerSeries(state, parseInt(props.tickerId)),
}))(ChannelLayoutPreview);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ChannelLayoutPreview/index.js